<template>
  <button
    v-if="disabled || loader"
    :class="'button button-' + layout + ' ' + (disabled || loader)"
    @click="callback($event)"
    disabled
  >
    <Loader v-if="loader" layout="mini white" />
    <slot></slot>
  </button>
  <button
    v-else
    :class="'button button-' + layout + ' ' + (disabled || loader)"
    @click="callback($event)"
  >
    <div class="row align-center justify-center">
      <Loader v-if="loader" layout="mini white" />
      <slot></slot>
    </div>
  </button>
</template>

<script>
import Loader from "@/components/Loader";
export default {
  name: "Button",
  components: { Loader },
  props: {
    layout: String,
    event: Function,
    disabled: Boolean,
    loader: Boolean,
  },
  methods: {
    callback: function (e) {
      this.$emit("click", e);
    },
  },
};
</script>

<style lang="scss">
@use "@/assets/scss/vars.scss" as *;

.button {
  i {
    margin-right: 7px;
  }
  border-radius: 40px;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2), 0 2px 2px rgba(0, 0, 0, 0.14),
    0 3px 1px -2px rgba(0, 0, 0, 0.12);
  &:hover {
    background-position: right center;
    opacity: 0.8;
  }

  &-gray {
    width: 209px;
    height: 34px;
    box-shadow: none;
    font-size: 15px;
    color: $gray-1;
    background: $gray-8;
    align-items: center;
    justify-content: center;
    display: flex;
    &:hover{
      background: $purple;
      color: white;
    }
    img {
      margin-right: 8px;
    }
    @media (max-width: $small) {
      font-size: 11px;
      width: 100%;
    }
  }

  &-gold {
    width: 150px;
    height: 34px;
    box-shadow: none;
    font-size: 15px;
    color: white;
    background: $supporter-1;
    align-items: center;
    justify-content: center;
    display: flex;

    img {
      margin-right: 8px;
    }
    @media (max-width: $small) {
      font-size: 11px;
      width: 100%;
    }
    &-2 {
      background: $gold-3;
      color: $white;
      width: 129px;
      height: 34px;
      box-shadow: none;
      font-size: 15px;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      display: flex;
    }
  }
  &-blue {
    &-m {
      background: $client-2;
      padding: 13px 18px;
      color: $white;
      font-weight: bold;
    }

    &-g {
      background-image: linear-gradient(to right, $blue-1, $blue-2);
      padding: 13px 40px;
      color: $white;
      font-weight: bold;
      font-size: 14px;
    }

    &-opac {
      background-color: $blue-1;
      padding: 13px 18px;
      color: $white;
      font-weight: bold;
      margin-bottom: 10px;
    }

    &-go {
      background-color: $client-2;
      color: $white;
      padding: 8px 14px;
      font-weight: bold;
      font-size: 15px;
    }
  }

  &-back {
    background: $white;
    color: $font-color;
    padding: 13px 18px;
    width: 100px;
    margin-top: 12px;
    margin-left: 7px;
    margin-bottom: 6px;
    font-weight: bold;
    display: none;
  }
  &-green {
    &-s {
      width: 124px;
      height: 25px;
      background: $supporter-1;
      color: $white;
      font-weight: bold;
      border-radius: 100px;
      font-size: 13px;
      text-align: center;
    }

    &-m {
      padding: 13px 18px;
      background: $supporter-1;
      color: $white;
      font-weight: bold;
      font-size: 14px;
      @media (max-width: $small) {
        font-size: 11px;
      }
    }

    &-g {
      padding: 13px 40px;
      background-image: linear-gradient(to right, $green-1, $green-2);
      color: $white;
      font-weight: bold;
      font-size: 15px;
    }
    &-go {
      background-color: $supporter-1;
      color: $white;
      padding: 8px 14px;
      font-weight: bold;
      font-size: 15px;

      &.white {
        background-color: $white;
        color: $green-2;
        border: 2px solid $green-2;
      }
    }
    &-dark {
      background-color: $green-2;
      color: $white;
      padding: 10px 14px;
      font-weight: bold;
      font-size: 14px;
      @media (max-width: $small) {
        font-size: 11px;
      }
      &-p {
        height: 29px;
        padding: 0px 12px;
        background-color: $green-2;
        color: $white;
        font-weight: bold;
      }
    }
  }

  &-red {
    &-s {
      width: 124px;
      height: 29px;
      border: 2px solid $red;
      background: $white;
      color: $red-1;
      font-weight: bold;
      border-radius: 100px;
      font-size: 13px;
    }
    &-m {
      padding: 13px 40px;
      border: 2px solid $red;
      background: $white;
      color: $red-1;
      font-weight: bold;
      font-size: 14px;
    }
    &-go {
      background-color: $red;
      color: $white;
      padding: 8px 14px;
      font-weight: bold;
      font-size: 15px;
      @media (max-width: $small) {
        font-size: 11px;
      }
    }
  }

  &-black {
    &-go {
      background-color: $gray-1;
      color: $white;
      padding: 8px 14px;
      font-weight: bold;
      font-size: 15px;
    }
  }

  &-purple {
    background-color: $supporter-1;
    color: $white;
    padding: 8px 14px;
    font-size: 14px;
  }

  &-white {
    &-s {
      padding: 8px 10px;
      border: 2px solid $blue-6;
      background-color: $white;
      color: $blue-6;
      font-weight: 300;
      font-size: 12px;
      box-shadow: none;
      color: $gray-2;
      border: 2px solid $gray-2;
      opacity: 0.7;
      &:hover {
        opacity: 1;
      }
    }
    &-m {
      padding: 8px 15px;
      background-color: $font-color;
      color: white;
      font-weight: 300;
      font-size: 15px;
      box-shadow: none;

      &-gray {
        padding: 8px 15px;
        border: 2px solid $font-color;
        background-color: $white;
        color: $font-color;
        font-weight: 300;
        font-size: 15px;
        box-shadow: none;
        color: $font-color;
        opacity: 0.7;
        &:hover {
          opacity: 1;
        }
      }
    }
    &-g {
      padding: 10px 15px;
      border: none;
      background: $white;
      color: $gray-1;
      font-weight: bold;
      font-size: 14px;
    }
    &-green {
      padding: 8px 15px;
      background: $supporter-1;
      font-size: 13px;
      box-shadow: none;
      font-weight: bold;
      color: white;
      border: 2px solid $supporter-1;

      &:hover {
        border: 2px solid $font-color;
        color: $font-color;
      }
    }
  }
  &-remote {
    &-continue {
      font-family: Work Sans;
      border-radius: 8px;
      width: 100%;
      border: none;
      box-shadow: none;
      height: 35px;
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
    }
    &-skip {
      color: #ccc;
      border: none;
      box-shadow: none;
      background: #fff;
      font-weight: 600;
      font-size: 14px;
      line-height: 16px;
      width: 85px;
    }
    &-newJob {
      height: 35px;
      padding: 0px 12px;
      border-radius: 8px;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      border-radius: 8px;
    }
    &-how {
      box-sizing: border-box;
      border-radius: 8px;
      font-weight: 500;
      font-size: 14px;
      line-height: 16px;
      padding: 9px 12px;
      background: none;
    }
  }
}
</style>
